import { render, staticRenderFns } from "./BuyKey.vue?vue&type=template&id=b0361918&scoped=true"
import script from "./BuyKey.vue?vue&type=script&lang=js"
export * from "./BuyKey.vue?vue&type=script&lang=js"
import style0 from "./BuyKey.vue?vue&type=style&index=0&id=b0361918&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0361918",
  null
  
)

export default component.exports